import { Injectable } from '@angular/core'
import { ComponentStore } from '@ngrx/component-store'
import { tap, firstValueFrom } from 'rxjs'
import { PersonaService } from '../services/persona/persona.service'
import {
  CreatePersonaInput,
  UpdatePersonaInput,
} from '../../_generated/graphql'

interface RoleplayState {
  selectedPersonaId: string
}

@Injectable({
  providedIn: 'root',
})
export class RoleplayStore extends ComponentStore<RoleplayState> {
  constructor(private personaService: PersonaService) {
    super({
      selectedPersonaId: '',
    })
  }

  getPersonas() {
    return this.personaService.getPersonas()
  }

  fetchPersonaById(id: string) {
    return firstValueFrom(this.personaService.getPersonaById(id))
  }

  createPersona(param: CreatePersonaInput) {
    return this.personaService.createPersona(param).pipe(
      tap(() => {
        console.log('Persona created successfully')
      }),
    )
  }

  updatePersona(param: UpdatePersonaInput) {
    return this.personaService.updatePersona(param).pipe(
      tap(() => {
        console.log('Persona updated successfully')
      }),
    )
  }

  deletePersona(id: string) {
    return this.personaService.deletePersona(id)
  }

  deletePersonas(ids: string[]) {
    return this.personaService.deletePersonas(ids)
  }
}
